const esTranslations = {
  translation: {
    menu: {
      items: {
        schedule_test: "Obtener Covid-19 probado",
        vax_yes_register: "Obtener tarjeta de vacuna",
        appointments: "Citas",
        logout: "Cierre de sesión",
        dashboard: "Tablero"
      }
    },
    appointment: {
      auth: {
        intro_text: "Por favor, verifique la fecha de nacimiento del paciente.",
        button: "Envíe"
      },
      card: {
        error: "Lo siento, no pudimos encontrar su cita.",
        error_api: "No pude encontrar la cita",
        intro_text: "Su cita está confirmada",
        qr_code_disclaimer:
          "Recibirá este código QR y la confirmación por mensaje de texto en breve, téngalo a mano. También asegúrese de traer una identificación del gobierno a su cita para verificación.",
        symptoms_disclaimer:
          "Si usted está exhibiendo síntomas similares a los del COVID, o ha sido expuesto a un caso positivo confirmado, por favor continúe siguiendo las pautas de la cuarentena.",
        thank_you: "Gracias por reservar su prueba con GoGet, Inc",
        id_disclaimer:
          "Asegúrese de llegar a su cita a tiempo y tenga a mano su identificación emitida por el gobierno.",
        sign_off: "Manténgase a salvo y manténgase bien.",
        button_schedule_test: "Programe otra prueba"
      },
      pay_disclaimer: {
        title: "Costo de la atención",
        intro_text: "El costo total de su cuidado es"
      },
      pay_error: {
        title: "Error de pago",
        error: "Lo sentimos, hubo un error al procesar su pago."
      },
      pending: {
        title: "Pendiente de la cita",
        intro_text: "Encontramos una cita pendiente que aún requiere pago.",
        button_pay_now: "Paga ahora",
        button_new_appointment: "Nuevo nombramiento"
      },
      result: {
        error_api: "No se puede recuperar el resultado",
        error_dob_match:
          "La fecha de nacimiento no coincide, por favor inténtelo de nuevo.",
        error_empty: "No pude encontrar el resultado de la prueba",
        summary_title: "El resultado de tu prueba es:",
        summary_subtitle:
          "Los resultados de nuestro laboratorio confirman que usted",
        positive_text: "TIENEN COVID-19",
        positive_next_step:
          "El virus estaba presente en la muestra que proporcionó. Aísle en su casa durante 10 días a partir de la fecha de la prueba o cuando se enfermó por primera vez. También haga que otras personas en su hogar sean examinadas. Continúe monitoreando el empeoramiento de los síntomas hasta por 10 días.",
        negative_next_step:
          "El virus no estaba presente en la muestra que proporcionó. Continúe monitoreando cualquier síntoma durante un máximo de 10 días si cree que tuvo una posible exposición.",
        button_lab_report: "Vea mi informe de laboratorio",
        button_view_faqs: "Ver FAQ's",
        faqs_title: "Si tiene más preguntas, lea nuestras preguntas frecuentes",
        dob_confirm:
          "Por favor, confirme su fecha de nacimiento para ver su resultado de Covid-19"
      },
      unavailable: {
        title: "Disponibilidad de la prueba",
        intro_text:
          "Todas nuestras localizaciones y pruebas programadas están ahora llenas. Por favor, vuelva pronto para ver si hay más vacantes.",
        faqs_title: "Si tiene más preguntas, lea nuestras preguntas frecuentes",
        button_view_faqs: "Ver FAQ's",
        status: "FULL"
      },
      vax_certificate: {
        header_title: "Certificado de la vacuna Covid-19",
        error_api: "Se ha producido un error al recuperar su certificado.",
        card_title: "Administrado por",
        card_subtitle: "Vacuna",
        certification_level: "Verificación de nivel {{level}} aprobada",
        error_empty: "No se ha encontrado ningún certificado.",
        add_booster_button: "Agregar refuerzo",
        booster_added_alert:
          "Por favor, espere 2-3 minutos para que aparezca su refuerzo en su certificado."
      }
    },
    schedule: {
      group_code_screener: {
        title: "Código de grupo",
        intro_text: "¿Tiene un código de grupo o de localización?",
        secondary_text:
          "Si no tienes uno, no te preocupes. Seleccione no y continúe el registro.",
        options: {
          yes: "Sí, tengo un código",
          no: "No, salta este paso"
        }
      },
      country_select: {
        intro_text: "¿Dónde quiere que tenga lugar su cita?"
      },
      pre_register_success: {
        intro_text: "Gracias por inscribirse",
        secondary_text:
          "Se le ha añadido a la lista de espera. Le enviaremos un mensaje de texto y un correo electrónico cuando le hayamos emparejado con un proveedor de vacunas de su zona que acepte citas.",
        button: "Hecho"
      },
      pre_register: {
        intro_text: "La forma más sencilla de vacunarse.",
        secondary_text:
          "<0>Cree su cuenta ahora y anticípese al proceso de programación de vacunas.</0> <1>A medida que se abran los sitios, coincidiremos y le notificaremos automáticamente la ubicación más cercana para confirmar su cita.</1>",
        button: "Enlístate ahora"
      },
      no_slots: {
        intro_text: "Lo sentimos, nos hemos quedado sin espacios para vacunas.",
        secondary_text:
          "Desafortunadamente, ya se han llenado todas las plazas de vacunación disponibles.",
        button: "Regresar al tablero"
      },
      group_code: {
        title: "Código de grupo",
        intro_text:
          "Por favor, introduzca su código de grupo o de localización",
        form: {
          group_code: {
            label: "Código de grupo o de localización"
          }
        },
        options: {
          no_code: "No tengo un código"
        }
      },
      is_patient: {
        title: "¿Para quién es esto?",
        intro_text: "¿Para quién es esto?",
        options: {
          yes: "Para mí.",
          no: "Para alguien más"
        }
      },
      gender: {
        title: "Género",
        intro_text: "Por favor, seleccione su género",
        options: {
          male: "Hombre",
          female: "Mujer",
          refuse: "Negarse a identificarse"
        }
      },
      covid_19_test_type: {
        intro_text: "Elija el tipo de prueba Covid-19",
        available_services: {
          pcr: {
            summary: "Resultados de mayor precisión en aprox. 48 horas",
            summary_2:
              "Estándar de oro en las pruebas de COVID: resultado más sensible",
            summary_3:
              "El tiempo resultante es de al menos 24 horas en la mayoría de los casos."
          },
          antigen: {
            summary: "Resultados de prueba rápidos en 15-30 minutos",
            summary_2:
              "15-30 minutos para obtener resultados: puede ayudar cuando tiene un tiempo limitado para esperar resultados, como tomar un vuelo.",
            summary_3:
              "Buena opción para entender si actualmente eres infeccioso",
            summary_4: "Gran opción para quienes experimentan síntomas."
          }
        },
        recommended: "Recomendado",
        error_empty: "No hay servicios disponibles en este momento",
        no_price: "Precio calculado al finalizar la compra"
      },
      pregnancy: {
        intro_text:
          "Para las mujeres: ¿Está embarazada o hay alguna posibilidad de que quede embarazada en el próximo mes?",
        options: {
          yes: "Sí",
          no: "No"
        },
        disclaimer: {
          intro_text: "Por favor, hable con su médico.",
          secondary_text:
            "Le recomendamos que hable con su médico o ginecólogo sobre la programación de la vacuna COVID-19.",
          button: "Volver a la página de inicio",
          button_secondary: "Regresa"
        }
      },
      allergies: {
        intro_text:
          "¿Tiene alergia a medicamentos, alimentos, un componente de una vacuna o al látex?",
        options: {
          yes: "Sí",
          no: "No"
        }
      },
      serious_reaction: {
        intro_text:
          "¿Ha tenido alguna vez una reacción grave después de recibir una vacuna?",
        options: {
          yes: "Sí",
          no: "no"
        }
      },
      long_term_health: {
        intro_text:
          "¿Tiene un problema de salud a largo plazo con enfermedad cardíaca, enfermedad pulmonar, asma, enfermedad renal, enfermedad metabólica (por ejemplo, diabetes), anemia u otro trastorno sanguíneo?",
        options: {
          yes: "Sí",
          no: "No"
        }
      },
      immune_system: {
        intro_text:
          "¿Tiene cáncer, leucemia, VIH / SIDA o cualquier otro problema del sistema inmunológico?",
        options: {
          yes: "Sí",
          no: "No"
        }
      },
      immune_system_medications: {
        intro_text:
          "En los últimos 3 meses, ¿ha tomado medicamentos que afecten su sistema inmunológico, como prednisona, otros esteroides o medicamentos contra el cáncer? medicamentos para el tratamiento de la artritis reumatoide, la enfermedad de Crohn o la psoriasis; o ha tenido tratamientos de radiación?",
        options: {
          yes: "Sí",
          no: "No"
        }
      },
      nervous_system: {
        intro_text:
          "¿Ha tenido una convulsión o un problema cerebral u otro problema del sistema nervioso?",
        options: {
          yes: "Sí",
          no: "No"
        }
      },
      blood_transfusion: {
        intro_text:
          "Durante los ultimos 90 dias recibio anticuerpos monoclonicos o de productos de la sangre, o le dieron inmunoglobulina o gamaglobulina o un medicamento antiviral?",
        options: {
          yes: "Sí",
          no: "No"
        },
        disclaimer: {
          intro_text:
            "Le recomendamos que hable con su médico antes de programar una cita.",
          button: "Volver a la página de inicio",
          button_secondary: "Regresa"
        }
      },
      recent_vaccinations: {
        intro_text: "¿Ha recibido alguna vacuna en las últimas 2 semanas?",
        options: {
          yes: "Sí",
          no: "No"
        },
        disclaimer: {
          intro_text:
            "Espere hasta que hayan pasado más de 2 semanas desde su vacuna anterior para programar su vacuna COVID-19.",
          button: "Volver a la página de inicio",
          button_secondary: "Regresa"
        }
      },
      race: {
        title: "Carrera",
        intro_text: "¿Cómo te describirías a ti mismo?",
        error: "Debe elegir al menos una opción",
        options: {
          race_american_indian: "Indio americano o nativo de Alaska",
          race_asian: "Asiático",
          race_black: "Negro o afroamericano",
          race_white: "Blanco o caucásico",
          race_hawaiian: "Nativo de Hawai u otra isla del Pacífico",
          other: "Otros"
        }
      },
      ethnicity: {
        title: "Etnicidad",
        intro_text: "¿Eres de origen hispano, latino o español?",
        options: {
          yes: "Sí",
          no: "No"
        }
      },
      symptoms: {
        title: "Síntomas",
        intro_text:
          "¿Está experimentando actualmente alguno de estos síntomas?",
        options: {
          symptom_fever: "Fiebre o escalofríos",
          symptom_cough: "Tos",
          symptom_short_breath: "Falta de aliento o dificultad para respirar",
          symptom_fatigue: "Fatiga",
          symptom_muscle_body_aches: "Dolores musculares o corporales",
          symptom_headache: "Dolor de cabeza",
          symptom_lack_of_smell: "Nueva pérdida del gusto u olfato",
          symptom_sore_throat: "Dolor de garganta",
          symptom_congestion_runny_nose: "Congestión o secreción nasal",
          symptom_nausea_vomitting: "Náuseas o vómitos",
          symptom_diarrhea: "Diarrea"
        }
      },
      contact_tracing: {
        title: "Rastreo de contactos",
        intro_text:
          "¿Ha estado en contacto con alguien que tiene un resultado de Covid-19 confirmado por el laboratorio?",
        options: {
          yes: "Sí",
          no: "No o no estoy seguro"
        }
      },
      public_places: {
        title: "Lugares públicos",
        intro_text:
          "Por favor, seleccione todos los lugares que ha visitado en los últimos 14 días.",
        error: "Debe elegir al menos una",
        options: {
          bars_restaurants_cafes: "Bares/Restaurantes/Cafés",
          gas_stations: "Gasolineras/Estaciones de carga eléctrica",
          medical_offices: "Consultorios médicos",
          place_of_work: "Edificio de oficinas/lugar de trabajo",
          retail_grocery_stores: "Tiendas minoristas y de comestibles",
          places_of_worship: "Lugares de culto/centros comunitarios",
          public_parks: "Parques públicos",
          other: "Cualquier otro lugar público con más de 5 personas",
          none: "Ninguno de los anteriores"
        }
      },
      patient_details: {
        title: "Detalles del paciente",
        intro_text: "Quien es el paciente",
        secondary_text:
          "Ingrese el nombre del paciente y la fecha de nacimiento tal como aparece en su identificación emitida por el gobierno (licencia de conducir o pasaporte)",
        form: {
          first_name: {
            label: "Nombre"
          },
          middle_name: {
            label: "Segundo nombre"
          },
          last_name: {
            label: "Apellido"
          },
          dob: {
            label: "Fecha de nacimiento"
          }
        }
      },
      flight_info: {
        intro_text: "Ingrese los detalles de su vuelo",
        form: {
          flight_airline: {
            label: "Aerolínea"
          },
          flight_number: {
            label: "Número de vuelo"
          },
          flight_date: {
            label: "Fecha de vuelo"
          },
          flight_origin: {
            label: "Origen del vuelo"
          },
          flight_destination: {
            label: "Destino del vuelo"
          }
        }
      },
      patient_address: {
        title: "Dirección del paciente",
        intro_text: "Ingrese la dirección particular del paciente",
        link_manual_address: "¿No encuentras tu dirección?",
        link_address_search: "Busque su direccion",
        form: {
          country: {
            label: "País"
          },
          street: {
            label: "Calle"
          },
          city: {
            label: "Ciudad"
          },
          state: {
            label: "Estado"
          },
          zip_code: {
            label: "Código postal"
          },
          search: {
            label: "Busque su direccion"
          }
        }
      },
      patient_contact: {
        title: "Dirección de correo electrónico",
        intro_text: "Y su correo electrónico para actualizaciones de citas",
        form: {
          email: {
            label: "Correo electrónico"
          }
        },
        terms:
          "Al elegir la siguiente opción, reconozco que he revisado y acepto electrónicamente los <2>términos y condiciones y la política de uso</2>"
      },
      patient_vitals: {
        title: "Detalles del paciente",
        intro_text: "Ahora vamos a confirmar algunos detalles médicos",
        form: {
          height: {
            label: "Altura"
          },
          weight: {
            label: "Peso"
          },
          medications: {
            label: "¿Tomando medicamentos recetados?"
          }
        }
      },
      pre_existing_conditions: {
        title: "Condiciones preexistentes",
        intro_text: "¿Alguna condición de salud preexistente?",
        options: {
          heart_disease: "Enfermedad cardíaca",
          diabetes: "Diabetes",
          respiratory_disease:
            "Enfermedades respiratorias (por ejemplo, asma o EPOC)",
          autoimmune_disease: "Enfermedad autoinmune",
          other_chronic_disease: "Otras condiciones crónicas",
          allergies: "Alergias"
        }
      },
      consent: {
        title: "Consentimiento",
        intro_text:
          "¿Da su consentimiento para que realicemos esta prueba de COVID-19?",
        form: {
          full_name: {
            label: "Firme su nombre completo"
          }
        },
        terms:
          "Al elegir la siguiente opción, reconozco que he revisado y acepto electrónicamente los <2>términos y condiciones y la política de uso</2>"
      },
      ggd_teaser: {
        title: "Próximamente",
        intro_text:
          "Estamos haciendo que la atención médica moderna sea fácil de encontrar y usar. Inscríbase hoy mismo en la lista de espera y reciba 60 días gratis de GoGetDoc.",
        form: {
          waitlist: {
            label: "Sí, quiero unirme a la lista de espera de GoGetDoc"
          }
        }
      },
      date: {
        title: "Fecha",
        intro_text: "Por favor, seleccione la fecha de su cita",
        selected_alert_text: "Usted seleccionó",
        error: "Debes elegir una fecha",
        error_api: "No pude conseguir fechas disponibles",
        error_empty: "No hay fechas disponibles"
      },
      time: {
        title: "Tiempo",
        intro_text: "Elija la hora de su cita",
        error: "Debes elegir un momento",
        error_api: "No pude conseguir horarios disponibles",
        error_empty:
          "Lo siento, no hay horarios disponibles en esta fecha en el lugar que eligió."
      },
      has_insurance: {
        title: "El seguro médico",
        intro_text: "¿Tiene el paciente seguro médico?",
        secondary_text:
          "No hay costo ni copago por este servicio. Sin embargo, si tiene seguro, les cobraremos una tarifa administrativa.",
        options: {
          yes: "Sí",
          no: "No, doy fe de no tener seguro"
        }
      },
      insurance_card: {
        title: "Escanear la tarjeta de seguro médico",
        button_retake: "Volver a tomar la foto",
        button_skip: "Saltar",
        skip_disclaimer:
          "Sus pruebas / vacunas de Covid-19 pueden ser cubiertas por el seguro. Al seleccionar omitir, confirma que no tiene seguro."
      },
      insurance_verification: {
        title: "Verificación del seguro",
        intro_text: "Por favor, verifique la información de su seguro",
        form: {
          payer: {
            label: "Nombre de la compañía de seguros",
            no_options_text: "Escriba el nombre de su compañía de seguros"
          },
          member_id: {
            label: "Identificación de miembro"
          },
          group_no: {
            label: "Número de grupo"
          },
          relationship: {
            label: "Relación con el suscriptor"
          }
        }
      },
      influenza_consent: {
        title: "Gripe Consentimiento",
        intro_text:
          "He leído o me han explicado la declaración informativa sobre la vacunación contra la gripe y entiendo los beneficios y riesgos. Solicito que la vacuna de la gripe se me administre a mí (o a la persona nombrada a continuación para la que estoy autorizado a hacer esta solicitud.)",
        form: {
          full_name: {
            label: "Firme su nombre completo"
          }
        }
      },
      influenza_ineligible: {
        intro_text:
          "Basándonos en sus respuestas a la pantalla anterior, hemos determinado que no es elegible para recibir la vacuna contra la gripe en este momento. Por favor, póngase en contacto con su proveedor de atención primaria.",
        button_continue: "Continuar sin la vacuna contra la gripe"
      },
      influenza_screening: {
        title: "Detección de la gripe",
        intro_text: "Por favor, responda a las siguientes preguntas:",
        options: {
          egg_allergy: "¿Tiene una alergia grave a los huevos?",
          life_threatening_reaction:
            "¿Ha tenido alguna vez una reacción mortal a la vacuna contra la gripe?",
          guillain_barre_syndrome:
            "¿Tiene antecedentes de síndrome de Guillain-Barré?",
          severely_ill: "¿Está usted moderada o gravemente enfermo hoy?",
          no: "No",
          yes: "Sí"
        }
      },
      location: {
        title: "Ubicación",
        error: "Debes elegir un lugar",
        error_api: "No pude conseguir los lugares disponibles",
        error_empty:
          "Lo sentimos, no pudimos encontrar ninguna ubicación cercana.",
        results: {
          title: "Los sitios de prueba cercanos",
          count: "{{count}} resultados encontrados"
        },
        preselected: {
          title: "Todas las localidades"
        }
      },
      service_selection: {
        title: "Selección del servicio",
        intro_text: "Seleccione los servicios que desea programar",
        error: "Debe elegir al menos un servicio",
        error_empty: "No se han encontrado servicios."
      },
      covid_19_confirmed_case: {
        intro_text:
          "¿Le han diagnosticado personalmente COVID-19 en los últimos 10 días?",
        options: {
          yes: "si",
          no: "No"
        },
        disclaimer: {
          intro_text: "Espere a recibir su vacuna COVID-19",
          secondary_text:
            "Según la respuesta proporcionada, le recomendamos que espere hasta que se complete su período de cuarentena y no muestre síntomas durante 48 horas antes de recibir la vacuna COVID-19.",
          button: "Regresa"
        }
      },
      time_appointment_one: {
        selected_location: "Lugar de vacunación que seleccionó",
        intro_text: "¿A qué hora funciona mejor?",
        error_empty: "No hay horarios disponibles para esta fecha.",
        error_api: "Error al cargar las horas disponibles"
      },
      time_appointment_two: {
        selected_location: "Lugar de vacunación que seleccionó",
        alert_text: "Elija la fecha para la segunda vacunación",
        intro_text: "Seleccione la fecha y la hora para la segunda dosis",
        error_empty: "No hay horarios disponibles para esta fecha.",
        error_api: "Error al cargar las horas disponibles"
      },
      symptoms_vax: {
        intro_text:
          "¿Está experimentando actualmente síntomas como fiebre, tos o falta de aliento?",
        options: {
          yes: "Sí",
          no: "No"
        },
        disclaimer: {
          intro_text: "Se recomienda la prueba COVID-19",
          secondary_text:
            "Basándonos en la respuesta dada, recomendamos que se registre para una prueba de PCR COVID-19 antes de recibir la vacuna COVID-19.",
          button: "Programe ahora",
          button_secondary: "Regresa"
        }
      },
      vax_consent: {
        intro_text: "Consentimiento de la vacuna",
        secondary_text:
          "Estoy de acuerdo en que la persona nombrada a continuación recibirá la vacuna indicada y que a esta persona se le pondrá una vacuna en su cuerpo para prevenir enfermedades infecciosas. Recibí una copia de la Autorización de uso de emergencia (EUA) para la vacuna COVID-19. Conozco los riesgos de las enfermedades que previenen estas vacunas y los beneficios y riesgos de las vacunas. Tuve la oportunidad de hacer preguntas sobre las enfermedades, las vacunas y cómo se administran (hoja de información de vacunas de los CDC). Soy un adulto que puede dar mi consentimiento legal para que la persona nombrada a continuación reciba las vacunas. Doy libre y voluntariamente mi permiso firmado para que se administren estas vacunas.",
        form: {
          full_name: {
            label: "Firme con su nombre completo"
          }
        },
        guardian: {
          intro_text: "Consentimiento de los padres/tutores para la vacuna",
          secondary_text:
            "Estoy de acuerdo en que la persona nombrada a continuación recibirá la vacuna indicada y que a esta persona se le pondrá una vacuna en su cuerpo para prevenir enfermedades infecciosas. Recibí una copia de la Autorización de uso de emergencia (EUA) para la vacuna COVID-19. Conozco los riesgos de las enfermedades que previenen estas vacunas y los beneficios y riesgos de las vacunas. Tuve la oportunidad de hacer preguntas sobre las enfermedades, las vacunas y cómo se administran (hoja de información de vacunas de los CDC). Soy un adulto que puede dar mi consentimiento legal para que la persona nombrada a continuación reciba las vacunas. Doy libre y voluntariamente mi permiso firmado para que se administren estas vacunas."
        }
      },
      occupation: {
        main_intro_text: "¿Asiste, trabaja o es voluntario en una escuela?",
        yes: "sí",
        no: "No",
        intro_text: "Detalles de ocupación",
        secondary_text: "Ingrese los detalles de su ocupación a continuación.",
        intro_text_school: "Detalles de la escuela",
        secondary_text_school:
          "Ingrese la información de su escuela a continuación.",
        not_employed:
          "Verifico que actualmente no estoy empleado o inscrito en la escuela",
        form: {
          occupation: "Ocupación",
          empolyer_name: "Nombre del empleador",
          work_address: "Dirección de trabajo",
          employer_phone: "Número de teléfono del empleador"
        },
        form_school: {
          school_name: "Nombre de Escuela",
          role: "Papel",
          role_options: {
            faculty: "Facultad",
            staff: "Personal",
            student: "Alumno"
          },
          location: "Ubicación de la escuela"
        },
        back_button: "Atrás"
      }
    },
    dashboard: {
      title: "Tablero de mandos",
      error_api: "Ocurrió un error.",
      error_empty: "No tienes citas.",
      button_new_test: "<0>Obtener</0><1>Covid-19 probado</1>",
      button_new_vax: "<0>Obtener</0><1>Tarjeta de vacuna</1>",
      appointments_title: "Equipo",
      certificates_title: "Certificados",
      certificates_empty: "No tienes certificados."
    },
    chat: {
      intro_text: "Chatear con soporte",
      form: {
        display_name: {
          label: "Introduzca su nombre..."
        }
      },
      button_start: "Inicie el chat",
      teaser_text: "Quiere hablar con un humano, ",
      teaser_text_vaxyes: "Tienes preguntas? Tenemos respuestas. ",
      teaser_button: "estamos aquí",
      teaser_button_url: "https://help.gogetdoc.com/es/"
    },
    auth: {
      login: {
        intro_text: "Empieza introduciendo tu número de móvil.",
        secondary_text:
          "Usaremos este número para comunicarnos con usted y darle acceso a sus registros.",
        form: {
          phone_number: {
            label: "Número de teléfono"
          },
          has_sms: {
            label: "¿Este teléfono puede aceptar SMS?"
          },
          dob: {
            label: "Fecha de nacimiento",
            error: {
              required: "Se requiere la fecha de nacimiento",
              invalid: "La fecha de nacimiento no es válida"
            }
          },
          first_name: {
            label: "Nombre de pila"
          },
          last_name: {
            label: "Apellido"
          }
        },
        termsGGV:
          'Al hacer clic en "siguiente", usted acepta los <2>Términos de Servicio</2> de GoGet, Inc y reconoce que ha leído la <6>Política</6> de Privacidad. También consiente en recibir llamadas o mensajes SMS, incluyendo por marcador automático, de GoGet, Inc y sus afiliados al número que usted proporcione con fines informativos incluyendo sus citas y resultados. Por la presente certifico, bajo pena de perjurio, que fui, o estaré, completamente vacunado contra COVID-19 con una vacuna autorizada por la FDA o la OMS, lo que significa que han pasado o habrán pasado dos semanas desde mi última dosis de vacuna autorizada - en este momento. Es posible que se aplique una tarifa de gestión para los usuarios internacionales. Usted entiende que usted puede optar por enviar un mensaje de texto <9>STOP</9> al 877-280-2151',
        termsGGT:
          'Al hacer clic en "siguiente", usted acepta los <2>Términos de Servicio</2> de GoGet, Inc y reconoce que ha leído la <6>Política</6> de Privacidad. También consiente en recibir llamadas o mensajes SMS, incluyendo por marcador automático, de GoGet, Inc y sus afiliados al número que usted proporcione con fines informativos incluyendo sus citas y resultados. Es posible que se aplique una tarifa de gestión para los usuarios internacionales. Usted entiende que usted puede optar por enviar un mensaje de texto <9>STOP</9> al 877-280-2151',
        button: "Entra en el sistema",
        error_api: "No se pudo procesar su solicitud"
      },
      two_factor: {
        form: {
          code: {
            label: "Código de verificación"
          }
        },
        button: "Verifique",
        button_resend: "Solicita otro código",
        code_by_phone:
          "Ahora estamos llamando al <1>{{phone}}</1> para proporcionar su código de autenticación. Espere un momento mientras conectamos la llamada."
      },
      verify: {
        intro_text: "Verifique la información del paciente",
        button: "Confirme",
        error_api: "Ocurrió un error"
      }
    },
    partner_redirect: {
      disclaimer:
        "Ahora se está transfiriendo a nuestro socio aprobado y de confianza, GoGetTested.com, para reservar su cita."
    },
    components: {
      covid19_test_card: {
        title: "Prueba Covid-19",
        appointment_id: "ID de cita",
        status: "Estado",
        result: "Ver resultado",
        confirmation: "Confirmación",
        complete_payment: "El pago completo"
      },
      covid19_vaccine_card: {
        dose: "Dosis {{dose}} de {{doses}}",
        button_confirm: "Confirmación",
        button_certificate: "Certificado",
        title: "Vacuna para el COVID-19"
      },
      patient_details: {
        date_of_birth: "Fecha de nacimiento"
      },
      loader: {
        title: "Cargando",
        intro_text:
          "Las cosas están tomando un poco más de tiempo de lo habitual.",
        no_refresh_text: "Por favor, no actualice su navegador."
      },
      location_card: {
        selected: {
          title: "Ubicación seleccionada"
        },
        operated_by: "Operado por",
        stats: {
          test_slots: {
            label: "Ranuras de prueba"
          },
          time_to_results: {
            label: "Tiempo para los resultados"
          },
          test_wait_time: {
            label: "Tiempo de espera de la prueba"
          }
        },
        button: {
          selected: "Seleccionado",
          unselected: "Seleccione esta ubicación"
        }
      },
      mapbox_location_autocomplete: {
        form: {
          address: {
            label: "Busca tu ubicación"
          }
        }
      },
      location_services_list: {
        title: "Servicios"
      },
      admin_patient_card: {
        registered_on: "Registrado en",
        menu: {
          items: {
            appointment: "Cita",
            contact: "Contacte con",
            test_result: "Resultado de la prueba",
            vitals_demographics: "Vitales y Demografía",
            pre_existing_conditions: "Condiciones preexistentes",
            symptoms: "Síntomas",
            billing: "Facturación",
            activity_history: "Historia de la actividad/contacto"
          }
        }
      },
      test_status_chip: {
        pending: "Pendiente",
        positive: "Positivo",
        negative: "Negativo",
        with_lab: "Con laboratorio",
        canceled: "Cancelado"
      },
      vax_yes_teaser: {
        teaser_text:
          "Obtenga su tarjeta de vacuna verificada, segura y gratuita",
        button: "Saber más"
      },
      vax_yes: {
        booster_type_register_form: {
          brand_input_label: "Marca",
          brand_label: "Marca",
          brand_label_none: "Ninguna seleccionada",
          dose_text: "Confirme la fecha y el número de lote de su refuerzo.",
          dose_label: "Numero de lote",
          booster_date_label: "Fecha de refuerzo"
        },
        vaccine_type_register_form: {
          brand_input_label: "Marca",
          brand_label: "Marca",
          brand_label_none: "Ninguna seleccionada",
          dose_text: "Confirme la fecha y el número de lote de cada dosis.",
          dose_title: "Dosis {{dose}}",
          dose_label: "Número de lote (Dosis {{dose}})",
          vaccination_date_label: "Fecha de vacunación (Dosis {{dose}})"
        },
        patient_details_register_form: {
          first_name_label: "Primer nombre",
          last_name_label: "Apellido",
          dob_label: "Fecha de nacimiento"
        }
      },
      image_upload: {
        upload_error: "Error subiendo imagen",
        upload_new_image: "Subir nueva imagen",
        file_size_error: "El tamaño de su archivo es demasiado grande"
      }
    },
    common: {
      next: "Siguiente",
      confirm: "Confirme",
      error: "Lo siento, ha ocurrido un error",
      page_not_found: "Lo siento, no pudimos encontrar esa página",
      go_home: "Ir al tablero de mandos",
      learn_more: "Aprende más",
      continue: "Continúa",
      total: "Total"
    },
    vax_yes: {
      vax_yes_booster_success: {
        intro_text: "Gracias {{first_name}}!",
        secondary_text: "Su registro de refuerzo se ha agregado correctamente.",
        review_text:
          "Nuestro equipo está revisando su solicitud ahora. Recibirá un enlace para acceder a su certificado de refuerzo de vacuna digital en breve. Comparta este enlace único con familiares y amigos para que ellos también puedan obtener sus tarjetas digitales:",
        share_link_text: "O comparte en:",
        button_next: "Regresar al Tablero"
      },
      vax_yes_booster_vaccine_card: {
        intro_text:
          "Proporcione una imagen de su tarjeta de vacuna de refuerzo.",
        secondary_text: "Asegúrese de que toda la tarjeta esté visible.",
        retake_photo: "Volver a tomar la foto",
        button_next: "Próximo",
        upload_image_text: "Preferir",
        upload_image_link: "¿subir una imagen?",
        take_photo_text: "Preferir",
        take_photo_link: "¿toma una foto?",
        button_upload_label: "Elegir imagen"
      },
      vax_yes_booster_vaccine_type: {
        intro_text: "¿Qué marca de vacuna de refuerzo recibió?",
        button_next: "Enviar"
      },
      vax_yes_register: {
        intro_text: "Obtenga su pase de vacuna gratuito, seguro y verificado",
        intro_text_non_us: "Obtenga su pase de vacuna seguro y verificado",
        secondary_text:
          "Felicidades, tienes la vacuna Covid-19. Ahora guarde un registro seguro en su teléfono de forma gratuita con VaxYes. En unos pocos y sencillos pasos, puede obtener un registro de vacuna digital seguro que puede usar para viajes, espectáculos en vivo y empleadores.",
        secondary_text_non_us:
          "Felicidades, tienes la vacuna Covid-19. Ahora guarde un registro seguro en su teléfono con VaxYes. En unos pocos y sencillos pasos, puede obtener un registro de vacuna digital seguro que puede usar para viajes, espectáculos en vivo y empleadores.",
        button: "Próximo"
      },
      vax_yes_register_payment: {
        intro_text: "Elija su propia contribución",
        secondary_text_us:
          "VaxYes es un servicio gratuito para nuestros miembros. Confiamos en que si le aportamos valor, nos apoyará de manera justa.",
        contribution_text_us: "La mayoría de las personas contribuyen con $ 2.",
        secondary_text_non_us:
          "VaxYes es un servicio para nuestros miembros. Confiamos en que si le aportamos valor, nos apoyará de manera justa.",
        error_message: "No pudimos iniciar su pago. Inténtalo de nuevo.",
        api_payment_error:
          "Hubo un error al enviar su solicitud de pago (error de API)",
        button: "Próximo"
      },
      vax_yes_register_payment_callback: {
        api_payment_processing_error: "Hubo un error al procesar su pago.",
        api_payment_validation_error: "No pudimos validar su pago"
      },
      vax_yes_register_step: {
        button_back: "atrás",
        progress: "Paso {{current}} de {{total}}",
        invalid_page: "Página inválida",
        error_api: "Hubo un problema al enviar sus datos"
      },
      vax_yes_register_photo_id: {
        intro_text:
          "Proporcione una imagen de su identificación con foto emitida por el gobierno",
        secondary_text:
          "Una licencia de conducir funciona bien. Asegúrese de que la identificación esté visible y enfocada.",
        retake_photo: "Volver a tomar la foto",
        button_next: "Próximo",
        upload_image_text: "Preferir",
        upload_image_link: "¿subir una imagen?",
        take_photo_text: "Preferir",
        take_photo_link: "¿toma una foto?",
        button_upload_label: "Elegir imagen"
      },
      vax_yes_register_vaccine_card: {
        intro_text: "Proporcione una imagen de su tarjeta de vacunación",
        secondary_text: "Asegúrese de que toda la tarjeta esté visible.",
        retake_photo: "Volver a tomar la foto",
        button_next: "Próximo",
        upload_image_text: "Preferir",
        upload_image_link: "¿subir una imagen?",
        take_photo_text: "Preferir",
        take_photo_link: "¿toma una foto?",
        button_upload_label: "Elegir imagen"
      },
      vax_yes_register_vaccine_type: {
        intro_text: "¿Qué marca de vacuna recibió?",
        button_next: "Próximo"
      },
      vax_yes_register_id_scan: {
        intro_text:
          "Escanee el código de barras que se encuentra en la parte posterior de su licencia de conducir.",
        skip_text: "¿Problemas para escanear el código de barras?",
        button_skip: "Saltar",
        verify_intro_text:
          "Verifique su nombre, apellido y fecha de nacimiento.",
        button_scan: "Escanear ID de gobierno",
        button_next: "Próximo"
      },
      vax_yes_register_contact: {
        intro_text: "Proporcione su dirección de correo electrónico.",
        secondary_text:
          "Lo usaremos para notificarle cuando su tarjeta esté lista.",
        form_label: "Correo electrónico",
        button_next: "Próximo"
      },
      vax_yes_register_success: {
        intro_text: "Gracias {{first_name}}!",
        secondary_text:
          "El registro de su tarjeta vax fue exitoso. Nuestro equipo está revisando su solicitud ahora. Recibirá un enlace para acceder a su certificado de vacuna digital en breve.",
        share_text:
          "Comparta este enlace único con familiares y amigos para que ellos también puedan obtener sus tarjetas digitales:",
        share_link_text: "O comparte en:",
        button_next: "Regresar al Tablero"
      },
      vax_yes_verify: {
        intro_text:
          "Ingrese la fecha de nacimiento del miembro para verificar el nivel de verificación de VaxYes",
        button_text: "Enviar"
      }
    }
  }
};

export { esTranslations };
